export default function Stub({ title }) {
  return (
    <div className="empty-state">
      <h3 className="mb-2">{title}</h3>
      <span className="badge badge-pending">Скоро</span>
      <p className="text-muted mb-2">Этот раздел появится в одной из следующих версий сервиса.</p>
    </div>
  );
}
